var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"staff_list_wrap"},[_vm._l((_vm.results),function(employee,index){return _c('Item',{key:index,attrs:{"employee":employee,"focusedItem":_vm.focusedItem},on:{"selectEmployee":_vm.selectEmployee}})}),(_vm.noResult)?_c('li',{staticClass:"no_search"},[_vm._v("\""+_vm._s(_vm.keyword)+"\" 없음")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }